
import { Suspense, useEffect } from 'react'
import ReactDOM from 'react-dom'

import { QueryClientProvider } from '@tanstack/react-query'

import { useResetRequestConfig } from './useResetRequestConfig'

import { queryClient } from 'core/config/request'
import { unregister } from '../../serviceWorker'
import Loading from 'common/components/loading'
import Toast from 'common/components/toast'
import useSetAppHeight from 'common/hooks/useSetAppHeight'
import Router from 'core/routes/Router'
import LanguageHelper from 'common/helpers/language'
import RequestHelper from 'common/helpers/request'
import DateHelper from 'common/helpers/date'

import 'common/styles/main.scss'
import 'core/config/sentry'

unregister()

const App = () => {
  useSetAppHeight()

  const { isResetting } = useResetRequestConfig()

  LanguageHelper.setI18nLanguage()
  DateHelper.setLocale(LanguageHelper.language)

  useEffect(() => {
    RequestHelper.setInterceptors()
  }, [])

  if (isResetting) {
    return <Loading full />
  }

  return (
    <Suspense fallback={<Loading full />}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Toast />
        </Router>
      </QueryClientProvider>
    </Suspense>
  )
}

ReactDOM.render(<App/>, document.getElementById('root'))
